import React, { useState } from 'react';
import { ruleLibraryService } from '../../../config/api';

const RuleSaveDialog = ({ ruleDefinition, onSave, onCancel }) => {
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        category: 'MOMENTUM', // Default
        tags: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.name.trim()) return;

        try {
            setLoading(true);
            setError(null);

            const payload = {
                name: formData.name,
                description: formData.description,
                category: formData.category,
                tags: formData.tags.split(',').map(t => t.trim()).filter(Boolean),
                ruleDefinition: ruleDefinition
            };

            const response = await ruleLibraryService.createUserRule(payload);
            onSave(response.data);
        } catch (err) {
            console.error('Error saving rule:', err);
            setError(err.message || 'Failed to save rule');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="space-y-4">
            <h3 className="font-bold text-lg">Save Rule to Library</h3>
            <p className="text-sm text-base-content/60">
                Persist this custom rule to your library to reuse it in other strategies.
            </p>

            {error && (
                <div className="alert alert-error text-sm">
                    <span>{error}</span>
                </div>
            )}

            <form onSubmit={handleSubmit} className="space-y-4">
                <div className="form-control w-full">
                    <label className="label">
                        <span className="label-text">Rule Name <span className="text-error">*</span></span>
                    </label>
                    <input
                        type="text"
                        placeholder="e.g. My RSI Oversold"
                        className="input input-bordered w-full"
                        value={formData.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        required
                        autoFocus
                    />
                </div>

                <div className="form-control w-full">
                    <label className="label">
                        <span className="label-text">Description</span>
                    </label>
                    <textarea
                        className="textarea textarea-bordered h-20"
                        placeholder="Describe what this rule does..."
                        value={formData.description}
                        onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                    ></textarea>
                </div>

                <div className="grid grid-cols-2 gap-4">
                    <div className="form-control w-full">
                        <label className="label">
                            <span className="label-text">Category</span>
                        </label>
                        <select
                            className="select select-bordered"
                            value={formData.category}
                            onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                        >
                            <option value="MOMENTUM">Momentum</option>
                            <option value="TREND">Trend</option>
                            <option value="REVERSAL">Reversal</option>
                        </select>
                    </div>

                    <div className="form-control w-full">
                        <label className="label">
                            <span className="label-text">Tags (comma separated)</span>
                        </label>
                        <input
                            type="text"
                            placeholder="rsi, intraday"
                            className="input input-bordered w-full"
                            value={formData.tags}
                            onChange={(e) => setFormData({ ...formData, tags: e.target.value })}
                        />
                    </div>
                </div>

                <div className="modal-action">
                    <button type="button" className="btn btn-ghost" onClick={onCancel}>Cancel</button>
                    <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading || !formData.name.trim()}
                    >
                        {loading && <span className="loading loading-spinner loading-xs"></span>}
                        Save Rule
                    </button>
                </div>
            </form>
        </div>
    );
};

export default RuleSaveDialog;
